import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { Card, CardContent } from "./components/ui/card";
import { useNavigate } from "react-router-dom";

const OrderHistory = () => {
  const [processedOrders, setProcessedOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProcessedOrders = async () => {
      try {
        const processedQuery = query(collection(db, "orders"), where("status", "==", "processed"));
        const processedSnapshot = await getDocs(processedQuery);
        setProcessedOrders(processedSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (error) {
        console.error("❌ Error fetching processed orders:", error);
      }
    };

    fetchProcessedOrders();
  }, []);

  return (
    <div className="mt-10 p-6 bg-gray-900 rounded-lg text-center">
      <h2 className="text-2xl font-bold mb-4">Order History</h2>
      <button onClick={() => navigate("/admin")} className="px-6 py-3 bg-gray-600 rounded text-white mb-4 hover:bg-gray-700">
        Back to Admin Dashboard
      </button>
      <div className="grid grid-cols-1 gap-4">
        {processedOrders.length > 0 ? (
          processedOrders.map((order) => (
            <Card key={order.id} className="bg-gray-900 p-4 rounded-lg shadow-md border border-gold">
              <CardContent>
                <h2 className="text-xl font-bold text-gold">Order ID: {order.id}</h2>
                <p className="text-md text-gray-400">Date: {order.date ? new Date(order.date).toLocaleString() : "Unknown"}</p>
                <p className="text-lg text-gray-400 font-semibold">
                  Final Price: {order.discountedTotal ? order.discountedTotal : order.total}$
                </p>
                  <p className="text-lg text-gray-400 font-semibold">
                  Final Price: {order.discountedTotal ?
  ((order.discountedTotal*89500)%5000>2500 ? ((order.discountedTotal*89500)-(order.discountedTotal*89500)%5000+5000)
   :((order.discountedTotal*89500)-(order.discountedTotal*89500)%5000)) 
  : ((order.total*89500)%5000>2500 ? ((order.total*89500)-(order.total*89500)%5000+5000)
     :((order.total*89500)-(order.total*89500)%5000)) }LBP
                </p>
                <p className="text-lg text-gray-400">Type: {order.orderType}</p>
              </CardContent>
            </Card>
          ))
        ) : (
          <p className="text-gray-400">No processed orders found.</p>
        )}
      </div>
    </div>
  );
};

export default OrderHistory;

